import { createRouter } from '@tanstack/react-router';
import { queryClient } from '@/shared/api/query-client';
import { RouteError, RouteNotFound } from '@/shared/ui/route-states';
import { routeTree } from '../routeTree.gen';

export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
  defaultErrorComponent: RouteError,
  defaultNotFoundComponent: RouteNotFound,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
